import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateWaadMutation } from "../../redux/services/waadService/waad.Services";

function AddWaad() {
    const navigate = useNavigate();
    const [createWaad, { isLoading }] = useCreateWaadMutation();
    const [formData, setFormData] = useState({
        waad_name: "",
        waad_code: "",
        description: "",
        status: 1, // ✅ Default 1 = Active
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.waad_name.trim()) {
            errorToast("Error", "Waad name is required");
            return;
        }

        try {
            const payload = {
                ...formData,
                status: parseInt(formData.status), // ✅ 1 or 0
            };

            const response = await createWaad(payload).unwrap();
            console.log(response);
            successToast("Success", "Waad Created Successfully");
            navigate("/waad");
        } catch (error) {
            console.log(error);
            errorToast("Error", error?.data?.message || "Failed To Create Waad");
        }
    };

    return (
        <div>
            {/* HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">Add Waad</h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active" aria-current="page">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/waad">Waad List</Link>
                            </li>
                            <li className="breadcrumb-item">Add Waad</li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate("/waad")}
                    >
                        <span>
                            <i className="fe fe-list me-1"></i>
                        </span>
                        Waad List
                    </button>
                </div>
            </div>

            {/* FORM */}
            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="container">
                            <div className="row">
                                {/* WAAD NAME */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="fw-semibold">
                                            Waad Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control custumform"
                                            placeholder="Enter Waad Name"
                                            name="waad_name"
                                            value={formData.waad_name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* WAAD CODE */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="fw-semibold">Waad Code</label>
                                        <input
                                            type="text"
                                            className="form-control custumform"
                                            placeholder="Enter Waad Code (e.g., W001)"
                                            name="waad_code"
                                            value={formData.waad_code}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                {/* DESCRIPTION */}
                                <div className="col-md-12 mt-3">
                                    <div className="form-group">
                                        <label className="fw-semibold">Description</label>
                                        <textarea
                                            className="form-control custumform"
                                            placeholder="Enter Description"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            rows="3"
                                        />
                                    </div>
                                </div>

                                {/* ✅ STATUS - 1 = Active, 0 = Inactive */}
                                <div className="col-md-6 mt-3">
                                    <div className="form-group">
                                        <label className="fw-semibold">Status</label>
                                        <select
                                            name="status"
                                            className="form-control"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option value={1}>Active</option>
                                            <option value={0}>Inactive</option>
                                        </select>
                                    </div>
                                </div>

                                {/* BUTTONS */}
                                <div className="col-md-12 mt-4">
                                    <div className="d-flex gap-2">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" />
                                                    Creating...
                                                </>
                                            ) : (
                                                "Submit"
                                            )}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => navigate("/waad")}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddWaad;